<template>
    <div id="covid">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1>Humboldt COVID-19 Resources</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <strong>General COVID-19 Local Information:</strong>
                </div>
                <div class="col-12 covid-resource">
                    <a href="https://humboldtgov.org/2018/Humboldt-Health-Alert" target="_blank">Humboldt Health Alert</a>
                    <br />
                    Find information on:
                    <ul>
                        <li>latest communication on COVID-19 from county Public Health</li>
                        <li>FAQ  about COVID-19</li>
                        <li>phone number and email for medical questions related to COVID-19</li>
                    </ul>
                </div>
                <div class="col-12 covid-resource">
                    <a href="https://humboldtgov.org/2705/Available-Services" target="_blank">Humboldt County Available Services</a>
                    <br />
                    Find information on:
                    <ul>
                        <li>Status of a variety of county services</li>
                    </ul>
                </div>
                <div class="col-12 covid-resource">
                    <strong>If You are Experiencing Symptoms</strong>
                    <br />
                    <a href="https://madriverhospital.com/article/covid" target="_blank">Mad River Hospital Self-Assessment Tool</a>
                    <br />
                    <a href="https://coronavirus.providence.org/" target="_blank">St. Joseph Hospital Self-Assessment Tool</a>
                </div>
                <div class="col-12 covid-resource">
                    <strong>For Families:</strong>
                    <br />
                    <a href="https://hcoe.org/covid-19/" target="_blank">Humboldt County Office of Education COVID-19 Resource Page</a>
                    <br />
                    Find information on:
                    <ul>
                        <li>school meal pick up times and locations</li>
                        <li>school closure status</li>
                        <li>distance learning resources</li>
                    </ul>
                </div>
                <div class="col-12 covid-resource">
                    <strong>For Help with your Energy Bill:</strong>
                    <br />
                    <a href="https://rcaa.org/energy-services" target="_blank">Redwood Community Action Agency</a>
                    <br />
                    Find information on:
                    <ul>
                        <li>utility and energy assistance</li>
                    </ul>
                </div>
                <div class="col-12 covid-resource">
                    <strong>En Español:</strong>
                    <br />
                    <a href="https://cdpueblo.com/" target="_blank">Centro del Pueblo</a>
                    <br />
                    Encuentre información acerca de:
                    <ul>
                        <li>Sus derechos durante el COVID-19</li>
                        <li>Consejos básicos de prevención en tiempos del COVID-19</li>
                        <li>Linea COVID-19 en español</li>
                    </ul>
                </div>
                <div class="col-12 covid-resource">
                    <strong>Food Resources:</strong>
                    <br />
                    <a href="https://lostcoastoutpost.com/2020/mar/16/food-hero-roundup-here-updating-list-humboldt-coun/" target="_blank">List of restaurants offering take-out and/or delivery</a>
                    <br />
                    <a href="https://www.foodforpeople.org/content/covid-19-response-resources/" target="_blank">Local food bank- Food for People</a>
                    <br />
                    Find information on:
                    <ul>
                        <li>food pantries near you</li>
                        <li>food distribution programs</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Covid"
    }
</script>

<style scoped>
    .covid-resource {
        margin-bottom: 15px;
    }
</style>